import { render, staticRenderFns } from "./SearchCategories.vue?vue&type=template&id=93b51534&scoped=true&"
import script from "./SearchCategories.vue?vue&type=script&lang=js&"
export * from "./SearchCategories.vue?vue&type=script&lang=js&"
import style0 from "./SearchCategories.vue?vue&type=style&index=0&id=93b51534&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b51534",
  null
  
)

export default component.exports